import { useState } from 'react';

import { StepItem, StepList } from './step-list';
import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/new/components/shadcn/dialog';

export const MatterCreationOnboarding = () => {
  const [isOpen, setIsOpen] = useState(true);

  const steps: StepItem[] = [
    {
      icon: <Icon className="lucide--pencil-line" />,
      title: 'Fill out matter details',
      description: 'Add basic information about the matter e.g. the name and code.',
    },
    {
      icon: <Icon className="lucide--gavel" />,
      title: 'Fill out legal issues',
      description:
        'Add the key issues that you want to explore. This will help the AI understand the context of the matter to determine which facts are relevant.',
    },
    {
      icon: <Icon className="lucide--users-round" />,
      title: 'Add colleagues',
      description:
        'Add any colleagues that you want to share this matter with. They will be able to see all documents and data within this matter.',
    },
    {
      icon: <Icon className="lucide--upload" />,
      title: 'Upload documents',
      description: 'Upload the documents that you want to explore. ',
    },
  ];

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="max-w-3xl" data-testid="matter-creation-onboarding-modal">
        <DialogHeader>
          <DialogTitle>
            <Icon className="lucide--folder" />
            Matter Creation
          </DialogTitle>
        </DialogHeader>
        <DialogDescription asChild>
          <div className="space-y-2 text-sm text-gray-600">
            <p>Matters are where you upload your documents for storage and analysis.</p>
            <p>
              For example you could create the matter <b>Smith v. Jones</b>, and then any documents relating to Smith v.
              Jones would live inside this matter.
            </p>
          </div>
        </DialogDescription>

        <StepList steps={steps} />

        <p className="text-xs text-gray-700">You can always add more documents and users later.</p>

        <DialogFooter className="justify-center">
          <Button variant="primary" className="px-6" onClick={() => setIsOpen(false)}>
            Got it!
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
